
import ProductsList from '@/graphql/queries/products/ProductsList'

export default {
  vessel: {
    title: {
      fontSize: 'lg',
      lg: {
        fontSize: '3xl'
      }
    },
    dot: {
      width: 'md',
      height: 'md',
      backgroundColor: 'red',
      borderRadius: 'full',
    },
    buttonContainer: {
      position: 'absolute',
      height: 'full',
      zIndex: 10
    },
    buttonContainerPrev: {
      $extend: 'buttonContainer',
      pinLeft: true
    },
    buttonContainerNext: {
      $extend: 'buttonContainer',
      pinRight: true
    },
    ribbonParent: {
      position: 'absolute',
      pinLeft: true,
      pinTop: true,
      zIndex: 10,
      overflow: 'hidden'
    },
    ribbon: {
      paddingY: '2xs',
      paddingX: 'xs',
      color: 'white',
      fontWeight: 'semibold',
      backgroundColor: 'success',
      fontSize: 'sm',
      width: 'full'
    }
  },
  async fetch() {
    const { data: featured } = await this.$graphql.query({
      clientId: 'eshop',
      query: ProductsList,
      variables: { where: { featured: true }, first: 4, orderBy: 'sortOrder_ASC' }
    })

    if (featured.nodes.length) {
      return this.products = featured.nodes
    }

    const { data: products } = await this.$graphql.query({
      clientId: 'eshop',
      query: ProductsList,
      variables: { first: 4, orderBy: 'sortOrder_ASC' }
    })

    this.products = products.nodes
  },
  data() {
    return {
      products: null
    }
  },
  computed: {
    mode() {
      return this.$screen.md ? 'horizontal' : 'vertical'
    },
    minHeight() {
      return this.products ? null : 'screen'
    },
    buttonAttrs() {
      return {
        color: 'black',
        padding: 'xs'
      }
    }
  },
  methods: {
    image(item) {
      return {
        fit: 'cover',
        ratio: 'square',
        ...item.image
      }
    },
    detailsLink(item) {
      const products = this.$pagePath('products')
      return `${products}/${item.slug}`
    },
    itemText(item) {
      if (this.$screen.md) {
        return {
          html: item.excerpt
        }
      }
    }
  }
}
